import React from 'react';
import ReportViewer from "./base/ReportViewer";

const ListeReservations = () => {

    return (
        <div style={{height: "100%"}}>
            <ReportViewer reportName={"Listereservationsreport"} />
        </div>
    );
}
export default ListeReservations;